import React, { useCallback, useEffect, useState } from 'react';
import '../FieldSample.scss';
import { Button,Tooltip } from '@mui/material';
import { errorResponse, fieldSampleAreaEditor} from '../../../store/common';
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import AddIcon from '@mui/icons-material/Add';
import CustomTablePagination from 'src/shared/TablePagination/CustomTablePagination';
import moment from 'moment-timezone';
import { useStoreContext } from 'src/store/context';
import LoadingSpinner from 'src/shared/loading/loading';
import { getSamples } from 'src/apis/getFuelSampleCalls';
import { SampleAndSubSamplesRow } from './SampleAndSubSamplesRow';
import { useAddAlert } from 'src/store/actions';
import { StyledTableCellBinary, StyledTableRowBinary } from 'src/shared/Styles/Styles';
import { alertMessages } from 'src/constants';


  /*Row to populate the header and sample portion */
  type SampleHeaderRowProps ={
    allParams: any
  }
  export const SampleHeaderRow: React.FC<SampleHeaderRowProps>=({allParams})=>{
    const [open, setOpen] = useState(allParams.row.opened);
    const [samples, setSamples] = useState<any[]>([]);
    const [samplesCallComplete, setSamplesCallComplete] = useState<boolean>(true);
    const [totalCount, setTotalCount] = useState<number>(0);
    const [page, setPage] = useState(0);
    const [state, setState] = useStoreContext();
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const addAlert = useAddAlert(setState);
    const [paramsForGetSamplesCallBack, setParamsForGetSamplesCallBack] = useState<any>();
    const [called, setCalled] = useState(false);

    /* this will check each sample to see if the sub_opened, add sub_clicked, and subsamples were clicked*/
    const checkSubClicked =useCallback((samplesForHeader:any, found: any, fromAddSample:boolean)=>{
      if (samplesForHeader) {
        samplesForHeader.forEach((sample: any) => {
          if (found?.samples) {
            found.samples.forEach((s:any) => {
              if (s.fuel_sample_id === sample.fuel_sample_id) {
                if(fromAddSample && s.fuel_sample_id ===allParams.sampleRecentlyAdded?.fuel_sample_id){
                  sample.sub_opened = true

                  sample.add_sub_clicked = false
                }
                else{
                  sample.sub_opened = s.sub_opened
                  sample.add_sub_clicked = s.add_sub_clicked
                }
                sample.subsamples = s.subsamples
              }
            })
          }
          else {
            if(fromAddSample){
              sample.sub_opened = true
              sample.add_sub_clicked = false
            }
            else{
              sample.sub_opened = false
              sample.add_sub_clicked = false
            }
          }
          allParams.setAddSampleCalled(false);
        })
      }
      setSamples(samplesForHeader);    
    },[ allParams]);

    /* checkAllSamples will check the samples and make sure each sample has value and pagination that is set to the usestates*/
    const checkAllSamples = useCallback((allSamples:any, pageInfo:any, samplesForHeader:any, sampleHeaders: any) =>{
      allSamples.forEach((sam:any) => {
        if (sam.fuel_type === sampleHeaders.fuel_type && sam.category === sampleHeaders.category
          && sam.sub_category === sampleHeaders.sub_category && sam.method === sampleHeaders.method) {
          sam.samples = samplesForHeader
          sam.pageInfo = pageInfo

        }
      })
      allParams.setAllSamps(allSamples);
      setTotalCount(pageInfo.total_count);
      setSamplesCallComplete(true);
    },[allParams])

    /* this will handle the promise and call once get sample call has been made. 
    it will match the header call to the getsample
    then make a call to checkSubClicked to determine if a sample has been pressed
    */
   
    const handleSampleCallResponse = useCallback((sampleHeaders: any, setSamplesCallComplete:any, request: any, fromAddSample: boolean) =>{
      (async()=>{
        try{
          const returnFromPromise:any = await getSamples(addAlert, setSamplesCallComplete, request);
          const samplesForHeader= returnFromPromise.samplesForHeader;
          const pageInfo = returnFromPromise.pageInfo;
          const allSamples = allParams.allSamps;
          let found = allSamples.find(item => item.fuel_type === sampleHeaders.fuel_type && item.category === sampleHeaders.category
            && item.sub_category === sampleHeaders.sub_category && item.method === sampleHeaders.method);
          if(request.subsamples){
            found ={
              ...found,
              subsamples: request.subsamples
            }
          }
          checkSubClicked(samplesForHeader, found, fromAddSample);
          checkAllSamples(allSamples, pageInfo, samplesForHeader, sampleHeaders);
        }
        catch(error){
          errorResponse(error, addAlert, alertMessages.fieldSampleHomeData);
        } 
      })();
    },[addAlert, allParams.allSamps, checkAllSamples, checkSubClicked]);

    /* this is the callback for deletion of the sample to update the sample view per
     header accordion. It will match the header to the sample and if it matches
     then it will make  new call to make sure the sample is actually deleted
    */
    useEffect(()=>{
      if(allParams.callBackToBeMade!==null && paramsForGetSamplesCallBack){
        if(allParams.callBackToBeMade.type?.includes('getSamples')){    
          if(
            paramsForGetSamplesCallBack.category === allParams.row.category &&
            paramsForGetSamplesCallBack.sub_category === allParams.row.sub_category &&
            paramsForGetSamplesCallBack.method === allParams.row.method &&
            paramsForGetSamplesCallBack.fuel_type === allParams.row.fuel_type
          ){
            allParams.setCallBackToBeMade(null);
            const sampleCallBack ={
              startDate: allParams.startDate,
              endDate: allParams.endDate, 
              siteId: paramsForGetSamplesCallBack.siteId, 
              status: allParams.sample_status,
              category: paramsForGetSamplesCallBack.category,
              subCategory: paramsForGetSamplesCallBack.sub_category,
              method: paramsForGetSamplesCallBack.method,
              fuel_type: paramsForGetSamplesCallBack.fuel_type,
              page: paramsForGetSamplesCallBack.pageInfo.page,
              rowsPerPage: paramsForGetSamplesCallBack.pageInfo.per_page,
              fromHandleDate: false
            }
            handleSampleCallResponse(allParams.row, setSamplesCallComplete, sampleCallBack, false)
          }
        }
  
      }
    },[ allParams.startDate, handleSampleCallResponse, allParams, paramsForGetSamplesCallBack
    ]);

    /* if a new page is clicked then get sample call will be requested*/
    const handleChangePage = (
      event: React.MouseEvent<HTMLButtonElement> | null,
      newPage: number,
    ) => {
      setPage(newPage);
      const sample = {
        ...allParams.row,
        status: allParams.sample_status,
        startDate: allParams.startDate,
        endDate: allParams.endDate,
        page: newPage,
        rowsPerPage: rowsPerPage
      }
      handleSampleCallResponse(allParams.row, setSamplesCallComplete, sample, false);
    };  
    /* this will hand the dropdown of pagination to getsample call*/
    const handleChangeRowsPerPage = (
      event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    ) => {
      setRowsPerPage(Number.parseInt(event.target.value, 10));
      if(Number.parseInt(event.target.value, 10)===-1){
        const nullPerPage ={
          ...allParams.row,
          status: allParams.sample_status,
          startDate: allParams.startDate,
          endDate: allParams.endDate,
          page: 0,
          rowsPerPage: null
        }
        handleSampleCallResponse(allParams.row, setSamplesCallComplete, nullPerPage, false);
      }
      else{
        const notNull = {
          ...allParams.row,
          startDate: allParams.startDate,
          status: allParams.sample_status,
          endDate: allParams.endDate,
          page: 0,
          rowsPerPage: Number.parseInt(event.target.value, 10)
        }
        handleSampleCallResponse(allParams.row, setSamplesCallComplete, notNull, false);
      }
      setPage(0);
    };
    /* this will open the sample accordion and make a call to get sample*/
    const openSampleAccordion = (nullPerPage:boolean)=>{
      setCalled(true)
      setOpen(!open);
      allParams.parentArray[allParams.index].opened = !open;
      allParams.setRowsStick(allParams.parentArray);
      if(open!==true){
        const samplePage = {
          ...allParams.row,
          status: allParams.sample_status,
          startDate: allParams.startDate,
          endDate: allParams.endDate,
          page: page,
          rowsPerPage: nullPerPage? null: rowsPerPage
        }
        allParams.setHeaderCalled(false)
        handleSampleCallResponse(allParams.row, setSamplesCallComplete, samplePage, false);
      }
    }

    /* this useEffects handles the submit. If submit was pressed on the RowSubSample.tsx then it will update the values
    to mae a new call to get Samples*/
    useEffect(()=>{
      if(allParams.sampleToSubmit){
        if(allParams.sampleToSubmit.submitCall){
          if(allParams.row.category===allParams.sampleToSubmit.sample.sampleCategory
            && allParams.row.fuel_type === allParams.sampleToSubmit.sample.sampleType
            && allParams.row.method===allParams.sampleToSubmit.sample.sampleMethod 
            && allParams.row.sub_category ===allParams.sampleToSubmit.sample.sampleSubCategory
            ){
              const sampleSubmitted = {
                ...allParams.row,
                subsamples: allParams.sampleToSubmit.subsamples,
                status: allParams.sample_status,
                startDate: allParams.startDate,
                endDate: allParams.endDate,
                page: page,
                rowsPerPage: rowsPerPage
              }
              handleSampleCallResponse(allParams.row, setSamplesCallComplete,sampleSubmitted, false);
              allParams.sampleToSubmit.submitCall = false
           }

        }
      }
    },[allParams.row, allParams.sampleToSubmit, allParams.endDate, allParams.startDate, page, rowsPerPage, handleSampleCallResponse, allParams.sample_status])

    /* any time the header is called and this sample is opened without being clicked, this one will be called*/
    useEffect(()=>{
      if(allParams.headerCalled && allParams.row.opened && !allParams.sampleClicked){
        allParams.setHeaderCalled(false)
        const headerCalled = {
          ...allParams.row,
          status: allParams.sample_status,
          startDate: allParams.startDate,
          endDate: allParams.endDate,
          page: page,
          rowsPerPage: rowsPerPage,
        }
        if(allParams.addSampleCalled){
          handleSampleCallResponse(allParams.row, setSamplesCallComplete, headerCalled, true);
        }
        else{
          handleSampleCallResponse(allParams.row, setSamplesCallComplete, headerCalled, false);
        }
      }
    },[allParams, handleSampleCallResponse, page, rowsPerPage])
    /* when another call is made for newly added sample*/
    useEffect(()=>{

        if(allParams.sampleClicked && allParams.row.opened && samples.length>0){
          allParams.setSampleClicked(false);
          setPage(0);
          setRowsPerPage(-1);
          const sampleUpdate = {
            ...allParams.row,
            status: allParams.sample_status,
            startDate: allParams.startDate,
            endDate: allParams.endDate,
            page: 0,
            rowsPerPage: null,
          }
          handleSampleCallResponse(allParams.row, setSamplesCallComplete, sampleUpdate, false);
        }
    },[allParams, handleSampleCallResponse, samples.length]);

        /* this call is to update the samples' hours to the correct format*/
    if(allParams.row.opened && samples.length<=0 && !called){
      allParams.setSampleClicked(false);
      let nullPerPage = true;
      setPage(0);
      setRowsPerPage(-1);
      const openedSampleFirst = {
        ...allParams.row,
        status: allParams.sample_status,
        startDate: allParams.startDate,
        endDate: allParams.endDate,
        page: 0,
        rowsPerPage: nullPerPage? null: rowsPerPage
      }
      handleSampleCallResponse(allParams.row, setSamplesCallComplete, openedSampleFirst, false);

      const found = allParams.allSamps.find((a:any)=> a.fuel_type===allParams.row.fuel_type && a.category ===allParams.row.category && a.sub_category === allParams.row.sub_category && a.method === allParams.row.method);
      if(found?.samples){
        found.samples.forEach((sample:any)=>{
          sample.date_tz = moment.tz(sample.sample, state.userTimeZone.id[0]).format('MM/DD/YYYY');
          sample.hour_tz = moment.tz(sample.sample, state.userTimeZone.id[0]).format('HH:ss');
        })
        setSamples(found.samples)
        setTotalCount(found.pageInfo.total_count);
      }
      setCalled(true)
    }

    return (
      <React.Fragment>
        <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
          <TableCell className="text-align-override">
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => openSampleAccordion(false)}
            >
              {open ? <KeyboardArrowDownIcon /> : <KeyboardArrowRightIcon />}
            </IconButton>
          </TableCell>
          <TableCell tabIndex={0} component="th" scope="row" style={{ fontWeight: 700 }} className="text-align-override">
            {allParams.row.fuel_type}
          </TableCell>
          <TableCell tabIndex={0} className='text-align-override'>{allParams.row.category}</TableCell>
          <TableCell tabIndex={0} className="text-align-override">{allParams.row.sub_category}</TableCell>
          <TableCell tabIndex={0} className="text-align-override">{allParams.row.method}</TableCell>
          <TableCell>
            {
              !allParams.siteInfo?.siteStatus.includes('Inactive') &&
            <Button variant="outlined" style={{ minWidth: '0', paddingRight: '2px', paddingLeft: '2px', backgroundColor: 'white'}} 
              aria-label="New Sample" 
              
              onClick={() => allParams.onEditExistingSample(allParams.row)}>
             <Tooltip title="New Sample" placement="top-start">
              <AddIcon/>
             </Tooltip>
            </Button>
            }
          </TableCell>
        </TableRow>

        <StyledTableRowBinary >
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box sx={{ margin: 1 }}>
                <Table size="small" aria-label="sampleHeaders" component={Paper}>
                  <colgroup>
                    <col width="1%" />
                    <col width="20%" />
                    <col width="20%" />
                    <col width="20%" />
                    <col width="25%" />
                    <col width="4%" />
                    {state.user && fieldSampleAreaEditor(state.user) ?(
                      <>
                      <col width="5%" />
                      <col width="5%" />
                      </>
                      ):(
                        <col width="10%" />

                      )
                    
                    }

                  </colgroup>
                  <TableHead>
                    <StyledTableRowBinary>
                      <td key ={`style-sample-header-accordion`} style={{padding: 'checkbox'}} className="headerParent" >&nbsp;</td>
                      <StyledTableCellBinary  tabIndex={0} className="text-align-override">DATE</StyledTableCellBinary>
                      <StyledTableCellBinary  tabIndex={0} className="text-align-override">TIME</StyledTableCellBinary>
                      <StyledTableCellBinary  tabIndex={0} className="text-align-override">SAMPLE AVG VALUE</StyledTableCellBinary>
                      <StyledTableCellBinary  tabIndex={0} className="text-align-override">SAMPLE STATUS</StyledTableCellBinary>
                      <td key ={`style-sample-header-submit-button`} style={{padding: 'checkbox'}} className="headerParent" >&nbsp;</td>
                      <td key ={`style-sample-header-delete-button`} style={{padding: 'checkbox'}} className="headerParent" >&nbsp;</td>
                      {
                        state.user && fieldSampleAreaEditor(state.user) && 
                        <td key ={`style-sample-header-fuel-type-button`} style={{padding: 'checkbox'}} className="headerParent" >&nbsp;</td>

                      }
                    </StyledTableRowBinary>
                  </TableHead>
                  <TableBody>         
                    {samplesCallComplete?(
                      samples && samples.length>0 && (
                        samples.map((sample, indexOfSample)=>
                          {
                            let paramsCreate ={
                              sample: sample, 
                              index: allParams.index,
                              indexchild: indexOfSample,
                              token: allParams.token,
                              allSamps: allParams.allSamps,
                              setDeletePressed: allParams.setDeletePressed,
                              deletePressed: allParams.deletePressed,
                              setSubSampleIdToDelete: allParams.setSubSampleIdToDelete,
                              subSampleIdToDelete: allParams.subSampleIdToDelete,
                              setSampleToSubmit: allParams.setSampleToSubmit,
                              setOpenSubmitModal: allParams.setOpenSubmitModal,
                              setOpenDeleteModal: allParams.setOpenDeleteModal,
                              setAllSamps: allParams.setAllSamps,
                              sampleToDelete: allParams.sampleToDelete,
                              setSampleToDelete: allParams.setSampleToDelete,
                              setTypeToDelete: allParams.setTypeToDelete,
                              typeToDelete: allParams.typeToDelete,
                              setSampleToReload: allParams.setSampleToReload,
                              sampleToReload: allParams.sampleToReload,
                              setArchivedVerbiage: allParams.setArchivedVerbiage,
                              setCallBackToBeMade: allParams.setCallBackToBeMade,
                              callBackToBeMade: allParams.callBackToBeMade,
                              setParamsForGetSamplesCallBack: setParamsForGetSamplesCallBack,
                              paramsForGetSamplesCallBack: paramsForGetSamplesCallBack,
                              row: allParams.row,
                              siteInfo: allParams.siteInfo
                            }
                            if(paramsCreate.sample){
                              return (
                                <SampleAndSubSamplesRow key={sample.fuel_sample_id} varsAndFuncsFieldSampleChild={paramsCreate}/>
                                )
                            }
                            else{
                              return null
                            }
                          }
                          
                        )
                     )
                    ):(
                      <div className='heightImportant'>
                        <LoadingSpinner/>
                      </div>
                    )  
                  }

                  </TableBody>
                </Table>
                <CustomTablePagination
                  rowsPerPageOptions={[5,10, 25, { label: 'All', value: -1 }]}
                  count={totalCount}
                  page={page}
                  rowsPerPage={rowsPerPage}
                  onPageChange={handleChangePage}
                  onChangeRowsPerPage={handleChangeRowsPerPage}
                />   
              </Box>
            </Collapse>
          </TableCell>
        </StyledTableRowBinary >
      </React.Fragment>
    );
  }